import List from '@material-ui/core/List';
import { useHistory } from "react-router-dom";
import Divider from '@material-ui/core/Divider';
import ShareIcon from '@material-ui/icons/Share';
import ListItem from '@material-ui/core/ListItem';
import { makeStyles } from '@material-ui/core/styles';
import Copyright from '../../../components/Copyright';
import { Avatar, Box, Grid } from '@material-ui/core';
import Assignment from '@material-ui/icons/Assignment';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import AccountCircle from '@material-ui/icons/AccountCircle';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';

/**
 * define styles for the component
*/
const useStyles = makeStyles((theme) => ({
  list: { 
    width: 250,
    flex: 1,
  },
  JustiLogo: {
    width: theme.spacing(8),
    height: theme.spacing(8),
  },
}));

/**
 * Custom `DrawerList` component declaration.
 * Define style and items(paths) to DrawerList 
 * @return DrawerList
*/
const DrawerList = ({ setShowDrawer }: { setShowDrawer: (newState: boolean) => void }): JSX.Element => {
  const classes = useStyles();
  const history = useHistory();

  const toggleDrawer = (open: boolean) => (
    event: React.KeyboardEvent | React.MouseEvent,
  ) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }
    setShowDrawer(open);
  };

  return (
    <Grid
      container 
      alignItems="center"
      justifyContent="center"
      className={classes.list}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <div style={{ height: '100%' }}>
        <div style={{ height: '80%' }}>
          <List>
            <ListItem button onClick={() => history.push("/docengine")}>
              <ListItemIcon><Assignment /></ListItemIcon>
              <ListItemText primary={'Lista de Plantillas'} />
            </ListItem>
            <Divider />
            <ListItem button onClick={() => history.push("/documents")}>
              <ListItemIcon><AssignmentIndIcon /></ListItemIcon>
              <ListItemText primary={'Mis solicitudes'} />
            </ListItem>
            <Divider />
            <ListItem button onClick={() => history.push("/share-documents")} >
              <ListItemIcon><ShareIcon /></ListItemIcon>
              <ListItemText primary={'Compartidos conmigo'} />
            </ListItem>
            <Divider />
            <ListItem button onClick={() => history.push("/profile")} >
              <ListItemIcon><AccountCircle /></ListItemIcon>
              <ListItemText primary={'Perfil'} />
            </ListItem>
          </List>
        </div>
        <div style={{ height: '20%', width: '100%', display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <Avatar
            alt="JustiExpress"
            src="/logo.png"
            className={classes.JustiLogo}
          />
          <Box mt={1}>
            <Copyright />
          </Box>
        </div>
      </div>
    </Grid>

  )
}

export default DrawerList